import { greensparksMuiBreakpoints } from "./index.js";

export const greensparksTouchTargetMin = 44;

export const greensparksMuiResponsiveFoundation = {
  breakpoints: greensparksMuiBreakpoints,
  touchTargetMin: greensparksTouchTargetMin,
  typography: {
    h4: {
      fontSize: "1.5rem",
      md: "2rem",
      lg: "2.125rem",
    },
    h5: {
      fontSize: "1.25rem",
      md: "1.5rem",
    },
  },
};
